
import { BrowserRouter as Router, Route,  Routes } from "react-router-dom";
import Login from "../pages/Login";
import Home from "../pages/Home";
import Department from "../pages/Department";
import User from "../pages/User";
import DepartmentMaster from "../pages/DepartmentMaster";
import CategoryMaster from "../pages/CategoryMaster";
import MenuMaster from "../pages/MenuMaster";
import ProductPage from "../pages/ProductPage";
import ProductViewPage from "../pages/ProductViewPage";
import Sidebar from "../components/Sidebar";
import MenuProductPage from "../pages/MenuProductPage";

function MyRoutes() {

  return (
    <div className="Routes">
      <Router>

      < div className="sidebar"> 
        <Sidebar />
        </div>
        <Routes>
          <Route exact path="/login" element={<Login />}/>
          <Route exact path="/departments" element={<Department />}/>
          <Route exact path="/department_master" element={<DepartmentMaster />}/>
          <Route exact path="/category_master" element={<CategoryMaster />}/>
          <Route exact path="/users" element={<User />}/>
          <Route exact path="/product" element={<ProductPage />}/>
          <Route exact path="/product_menu" element={<MenuProductPage />}/>
          <Route exact path="/product_view" element={<ProductViewPage />}/>
          <Route exact path="/menu" element={<MenuMaster />}/>
          <Route exact path="/" element={<Home />}/>
        </Routes>
      </Router>
    </div>
  );
}

export default MyRoutes;